import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import TextWithReadMoreDiv from '../../Components/ReadmoreDiv';
import API from '../../Api/Api';
import { IMAGE_PATHS } from '../../Functions/Constant';
import InfoTooltip from '../../Components/InfoTooltip';
import ConfirmationPopup from '../../Components/ConfirmationPopup';
import Confin from '../../Components/confin';
import ButtonsVariant from '../../Components/Button/ButtonVariant'; // Fixed: Use default import

const About = ({ experienceRef }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState({ about: '', profile_title: '' });
    const [showPopupC, setShowPopupC] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const formikRef = useRef(null);
    const [profileTitleLimitExceeded, setProfileTitleLimitExceeded] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [aboutWordLimitExceeded, setAboutWordLimitExceeded] = useState(false);
    const [popupData, setPopupData] = useState({
        isOpen: false,
        title: "",
        message: "",
        onClose: () => { },
        onConfirm: () => { },
    });

    const [profileTitleCursorPosition, setProfileTitleCursorPosition] = useState(0); // Cursor position for profileTitle
    const [aboutCursorPosition, setAboutCursorPosition] = useState(0); // Cursor position for about textarea

    const handleShow = () => {
        setIsEditMode(true);
        setShow(true);
    };

    const handleClose = (type = 0) => {
        const currentValues = formikRef.current?.values || {};
        const initialValues = {
            about: userData.about || "",
            profileTitle: userData.profile_title || "",
        };
        const isFormChanged =
            currentValues.about !== initialValues.about ||
            currentValues.profileTitle !== initialValues.profileTitle;

        if (isFormChanged && type === 0) {
            setShowPopupC(true);
        } else {
            setShow(false);
            formikRef.current?.resetForm();
            setIsEditMode(false);
            setPopupData({
                isOpen: false,
                title: "",
                message: "",
                onClose: () => { },
                onConfirm: () => { },
            });
        }
    };

    const validationSchema = Yup.object().shape({
        about: Yup.string()
            .test("maxWords", "Maximum character limit reached", function (value) {
                if (!value) return true;
                const wordCount = value.trim().split(/\s+/).length;
                return wordCount <= 500;
            })
            .test("maxWords", "Maximum character limit reached", function (value) {
                if (!value) return true;
                const wordCount = value.trim().split(/\s+/).length;
                return wordCount <= 500;
            })
            .required("Description is required"),
        profileTitle: Yup.string()
            .required("Profile Title is required")
            .test("maxWords", "Maximum character limit reached", function (value) {
                if (!value) return true;
                const wordCount = value.trim().split(/\s+/).length;
                return wordCount <= 20;
            })
            .test("maxWords", "Maximum character limit reached", function (value) {
                if (!value) return true;
                const wordCount = value.trim().split(/\s+/).length;
                return wordCount <= 20;
            }),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        try {
            const payload = {
                about: values.about,
                profile_title: values.profileTitle,
            };

            const response = await API.put(`/user/update-about-profile-title`, payload);
            setPopupData({
                isOpen: true,
                title: "Success!",
                message: "Your details have been updated successfully.",
                onConfirm: () => {
                    window.location.reload();
                },
                onClose: () => setPopupData({ isOpen: false }),
            });

            setUserData({
                about: values.about,
                profile_title: values.profileTitle,
            });

            resetForm();
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    const fetchUserData = async () => {
        try {
            const response = await API.get(`/user`);
            if (response.user) {
                setUserData({
                    about: response.user.about || '',
                    profile_title: response.user.profile_title || '',
                });
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);
    // Function to count words
    const countWords = (str) => {
        if (!str) return 0;
        return str.trim().split(/\s+/).filter(word => word.length > 0).length;
    };
    return (
        <section className="pb-[15px] px-4" ref={experienceRef}>
            <Container>
                <Row>
                    <Col xs={12} md={12} className={`${((userData.profile_title == null || userData.profile_title == "") && (userData.about == null || userData.about == "")) ? "p-0" : ""}`}>
                        <div className={`flex justify-between items-baseline ${(!userData.profile_title && !userData.about) ? "bg-white rounded-lg p-6 border border-gray-200 shadow-lg" : ""}`}>
                            <div>
                                <h3 className={`text-[22px] font-bold text-gray-900 mb-2 leading-[1.4] ${(!userData.profile_title && !userData.about) ? "mt-1" : "mt-3"}`}>
                                    About <InfoTooltip text="Give a quick professional intro to help others understand your background." />
                                </h3>
                            </div>
                            {((userData.profile_title == null || userData.profile_title == "") && (userData.about == null || userData.about == "")) && (
                                <div className="cl-plu">
                                    <i
                                        className="fas fa-plus black-class font-thin text-[27px] cursor-pointer i-p"
                                        onClick={handleShow}
                                    ></i>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
                {(userData.profile_title != "" || userData.about != "") && (
                    <Row className="bg-white rounded-lg p-6 border-1 mb-4 !pr-[14px]">
                        <Col lg={11} md={10} sm={10} xs={10}>
                            <p className="text-gray-700 leading-[1.4]">  <TextWithReadMoreDiv text={userData.about.replace(/\n/g, "<br />")} /></p>
                        </Col>
                        <Col lg={1} md={1} sm={1} xs={2} className="pr-0 flex justify-end">
                            <div className="cl-plu">
                                <i
                                    className="fas fa-pencil-alt black-class font-bold text-[15px] cursor-pointer i-p !top-[5px]"
                                    onClick={handleShow}
                                ></i>
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} className="zl">
                <Modal.Header closeButton className="p-4">
                    <Modal.Title className="text-lg font-bold text-gray-900">
                        {isEditMode ? "Edit About" : "Add About"}
                    </Modal.Title>
                </Modal.Header>
                <Formik
                    enableReinitialize
                    initialValues={{
                        about: userData.about || "",
                        profileTitle: userData.profile_title || "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={formikRef}
                >
                    {({ handleSubmit, isSubmitting, values, setFieldValue }) => (
                        <Form onSubmit={handleSubmit}>
                            <div className="relative pt-[15px] pb-0 p-[28px]">
                                <Form.Group className="mb-3 leading-[1.5]">
                                    <Form.Label className="mb-0 text-g">Profile Title *</Form.Label>
                                    <Field name="profileTitle">
                                        {({ field, form }) => {
                                            const wordCount = field.value ? field.value.trim().split(/\s+/).length : 0;
                                            const remainingWords = 20 - wordCount;
                                            const handlePaste = (e) => {
                                                e.preventDefault();
                                                if (remainingWords <= 0) return;

                                                const pastedText = e.clipboardData.getData('text');
                                                const pastedWords = pastedText.trim().split(/\s+/).filter(word => word.length > 0);
                                                const wordsToPaste = pastedWords.slice(0, remainingWords).join(' ');

                                                const beforeCursor = field.value.substring(0, profileTitleCursorPosition);
                                                const afterCursor = field.value.substring(profileTitleCursorPosition);
                                                const updatedText = beforeCursor + (beforeCursor && wordsToPaste ? ' ' : '') + wordsToPaste + (afterCursor ? ' ' + afterCursor : '');
                                                setFieldValue("profileTitle", updatedText);
                                                setProfileTitleCursorPosition(beforeCursor.length + (beforeCursor ? 1 : 0) + wordsToPaste.length);
                                            };

                                            const handleSelect = (e) => {
                                                setProfileTitleCursorPosition(e.target.selectionStart);
                                            };

                                            return (
                                                <div>
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        className="form-control fomc-cls "
                                                        placeholder="Ex: Software Engineer with 5+ years of experience"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const words = value.trim().split(/\s+/);
                                                            const isOverLimit = words.length > 20;

                                                            setProfileTitleLimitExceeded(isOverLimit);

                                                            if (!isOverLimit || value === "") {
                                                                form.setFieldValue("profileTitle", value);
                                                            }
                                                        }}
                                                        onPaste={handlePaste}
                                                        onSelect={handleSelect}
                                                        onClick={handleSelect}
                                                    />
                                                    <div className="relative">
                                                        <div className="flex flex-col">
                                                            <ErrorMessage name="profileTitle" component="div" className="text-danger text-sm" />
                                                            {profileTitleLimitExceeded && (
                                                                <div className="text-danger text-sm">Maximum character limit reached</div>
                                                            )}
                                                            <div className="absolute right-0 text-sm text-gray-500">
                                                                {wordCount}/20 words
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    </Field>
                                </Form.Group>

                                <Form.Group className="leading-[1.5] mb-[100px]">
                                    <Form.Label className="mb-0 text-g">You can share your experience, industry background, skills, achievements, or past roles. *</Form.Label>
                                    <Field name="about">
                                        {({ field, form }) => {
                                            const wordCount = field.value ? field.value.trim().split(/\s+/).length : 0;
                                            const remainingWords = 500 - wordCount;

                                            const handlePaste = (e) => {
                                                e.preventDefault();
                                                if (remainingWords <= 0) return;

                                                const pastedText = e.clipboardData.getData('text');

                                                // Split into words but preserve spaces and newlines
                                                const pastedParts = pastedText.split(/(\s+)/); // Split and keep spaces/newlines

                                                let wordsAdded = 0;
                                                let finalText = '';

                                                for (const part of pastedParts) {
                                                    if (part.trim() === '') {
                                                        // It's a space, tab, or newline
                                                        finalText += part;
                                                    } else if (wordsAdded < remainingWords) {
                                                        finalText += part;
                                                        wordsAdded++;
                                                    } else {
                                                        break;
                                                    }
                                                }

                                                const beforeCursor = field.value.substring(0, aboutCursorPosition);
                                                const afterCursor = field.value.substring(aboutCursorPosition);

                                                const updatedText = beforeCursor + finalText + afterCursor;
                                                setFieldValue("about", updatedText);
                                                setAboutCursorPosition(beforeCursor.length + finalText.length);
                                            };

                                            const handleSelect = (e) => {
                                                setAboutCursorPosition(e.target.selectionStart);
                                            };

                                            return (
                                                <div>
                                                    <textarea
                                                        {...field}
                                                        className="form-control fomc-cls !min-h-[175px]"
                                                        rows={3}
                                                        style={{ resize: "none" }}
                                                        placeholder="List your major duties and successes, highlighting specific projects."
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const words = value.trim().split(/\s+/);
                                                            const isOverLimit = words.length > 500;

                                                            setAboutWordLimitExceeded(isOverLimit);

                                                            if (!isOverLimit || value === "") {
                                                                form.setFieldValue("about", value);
                                                            }
                                                        }}
                                                        onPaste={handlePaste}
                                                        onSelect={handleSelect}
                                                        onClick={handleSelect}
                                                    />
                                                    <div className="relative">
                                                        <div className="flex flex-col">
                                                            <ErrorMessage name="about" component="div" className="text-danger text-sm" />
                                                            {aboutWordLimitExceeded && (
                                                                <div className="text-danger text-sm">Maximum character limit reached</div>
                                                            )}
                                                            <div className="absolute right-0 text-sm text-gray-500">
                                                                {wordCount}/500 words
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    </Field>
                                </Form.Group>
                            </div>
                            <hr className="border-gray-300 mb-4 hrb" />
                            <div className="absolute bottom-0 left-0 w-full bg-white p-4 border-t border-gray-300 flex rounded-b-lg justify-end">
                                {/* <Button
                                    type="submit"
                                    disabled={isSubmitting || loading}
                                    className="btn-explore-white"
                                >
                                    Save
                                </Button> */}
                                <ButtonsVariant
                                    ariaLabel="submit-button"
                                    type="submit"
                                    //   href="#"
                                    className="mx-[10px]"
                                    variant="blackToWhite"
                                    size="xs"
                                    title="Save"
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>
            {popupData.isOpen && (
                <Confin
                    isOpen={popupData.isOpen}
                    title={popupData.title}
                    message={popupData.message}
                    onClose={() => setPopupData({ isOpen: false })}
                    onConfirm={() => {
                        setTimeout(() => {
                            window.location.reload();
                        }, 300);
                    }}
                    showCancelButton={false}
                    onDiscard={false}
                    actionType="success"
                />
            )}
            {showPopupC && (
                <Confin
                    isOpen={showPopupC}
                    title="Discard Changes?"
                    message="Are you sure you want to discard all changes?"
                    onClose={() => setShowPopupC(false)}
                    onDiscard={() => {
                        handleClose(1);
                        setShowPopupC(false);
                    }}
                    loading={loading}
                    showCancelButton={true}
                    onConfirm={false}
                    isSuccess={isSuccess}
                    actionType="onDiscard"
                />
            )}
        </section>
    );
};

export default About;